













































import { Component, Prop, Vue } from 'vue-property-decorator'
import ProfileDetail from '@/components/ProfileDetail.vue'

@Component({
  components: { ProfileDetail }
})
export default class AboutUs extends Vue {
  @Prop()
  memberList!: any
}
